/* DESPI — evenements Meta propres au funnel.
   Expose window.despiTrack(nom, parametres). Charge apres api.js, avant app.js et flow.js.

   POURQUOI CE FICHIER EXISTE. Shopify envoie tout seul PageView, AddToCart,
   InitiateCheckout et Purchase — verifie en direct. Mais deux etapes lui echappent, et ce
   sont justement les plus utiles pour piloter une campagne :

   1. ViewContent. Nos pages sont des pages Shopify de type `page`, pas `product` : Shopify
      ne peut pas deviner qu'il s'agit d'une consultation produit. Meta perd l'etape
      intermediaire qui sert a optimiser au demarrage et a batir le reciblage.

   2. La GENERATION DU PORTRAIT. C'est le signal d'intention le plus fort du parcours :
      une cliente qui a envoye sa photo, attendu vingt secondes et vu son portrait est
      incomparablement plus proche de l'achat qu'une visiteuse quelconque. Aucun evenement
      ne le marquait. On envoie `Lead`, un evenement STANDARD — Meta optimise mal sur les
      evenements personnalises, et c'est sur celui-la qu'on voudra optimiser tant que les
      achats sont trop rares pour nourrir l'algorithme.

   PRUDENCE. `fbq` est pose par le Web Pixel de Shopify, pas par nous : il peut etre absent
   (bloqueur, sandbox, app desinstallee). Rien ici ne doit jamais interrompre le parcours —
   un portrait qui ne s'affiche pas parce qu'un mouchard a echoue serait absurde.
*/
(function () {
  'use strict';

  // le style REELLEMENT parcouru : la cliente a pu en changer depuis le panneau d'edition,
  // et une conversion attribuee au mauvais style fausserait la lecture des campagnes
  var STYLE = function () {
    return (window.despiApi && window.despiApi.style())
      || window.DESPI_STYLE || 'wild-pirates';
  };

  /** Empeche de compter deux fois le meme evenement (rechargement, retour arriere). */
  function dejaVu(cle) {
    try {
      if (sessionStorage.getItem(cle)) return true;
      sessionStorage.setItem(cle, '1');
      return false;
    } catch (e) {
      return false;   // stockage indisponible : on prefere un doublon a un evenement perdu
    }
  }

  /* Le pixel est pose par le Web Pixel de Shopify, de facon ASYNCHRONE : au moment ou nos
     scripts s'executent, `fbq` n'existe pas encore. On patiente donc au lieu d'abandonner.

     Ce detail a coute un evenement entier : la premiere version posait le marqueur
     d'unicite AVANT de constater l'absence de `fbq`, si bien que l'evenement etait perdu
     pour de bon — et sans le moindre signe, puisque tout avait l'air de fonctionner.
     Le marqueur n'est desormais pose qu'une fois l'evenement REELLEMENT parti. */
  var ATTENTE_MS = 300;
  var ESSAIS_MAX = 30;   // ~9 s : au-dela, le pixel est absent (bloqueur, app retiree)

  function envoyer(nom, params, uneFois, essai) {
    try {
      if (typeof window.fbq === 'function') {
        if (uneFois && dejaVu('despi_evt_' + uneFois)) return;
        window.fbq('track', nom, params || {});
        return;
      }
      if ((essai || 0) < ESSAIS_MAX) {
        setTimeout(function () { envoyer(nom, params, uneFois, (essai || 0) + 1); }, ATTENTE_MS);
      }
    } catch (e) {
      /* le suivi ne doit jamais casser une vente */
    }
  }

  /**
   * Envoie un evenement standard Meta, des que le pixel est disponible.
   * @param {string} nom        evenement STANDARD (ViewContent, Lead...)
   * @param {object} [params]   parametres Meta
   * @param {string} [uneFois]  cle d'unicite ; l'evenement ne partira qu'une fois par session
   */
  function despiTrack(nom, params, uneFois) {
    envoyer(nom, params, uneFois, 0);
    return true;
  }

  /** La cliente consulte le produit. */
  function vueProduit() {
    despiTrack('ViewContent', {
      content_type: 'product',
      content_ids: [STYLE()],
      content_name: 'DESPI Portrait',
    }, 'view_' + STYLE());
  }

  /**
   * Le portrait vient d'etre affiche : l'intention est etablie.
   * Une cle par generation, pour ne pas recompter au rechargement de la page.
   */
  function portraitAffiche(generationId) {
    despiTrack('Lead', {
      content_type: 'product',
      content_ids: [STYLE()],
      content_name: 'DESPI Portrait preview',
    }, 'lead_' + (generationId || 'inconnu'));
  }

  window.despiTrack = despiTrack;
  window.despiTrack.vueProduit = vueProduit;
  window.despiTrack.portraitAffiche = portraitAffiche;
})();
